module.exports = __webpack_public_path__ + "assets/img/teacher (27).14d7b6d3.png";